import productOne from "../../assets/images/productOne.webp"
import productTwo from "../../assets/images/productTwo.webp"
import productThree from "../../assets/images/productThree.webp"

export default function ImageStack() {
    return (
        <div className="stack">
          <div className="stack__card stack__card--left">
            <img src={productOne} alt="" />
          </div>
    
          <div className="stack__card stack__card--right">
            <img src={productTwo} alt="" />
          </div>
    
          <div className="stack__card stack__card--center">
            <img src={productThree} alt="" />
          </div>
          
        </div>
      );
}